import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-meta-text-input',
  templateUrl: './meta-text-input.component.html',
})
export class MetaTextInputComponent extends FieldType {}
